import modal from './modal';
import modalBottom from './modal-bottom';

const header = document.querySelector('.m-header');
const btnMenu = header?.querySelector('.btn-menu');
const btnMenuClose = header?.querySelector('.btn-menu-close');
const btnCart = header?.querySelector('.btn-cart');
const btnLogin = header?.querySelectorAll('.btn-login');
const btnAccount = header?.querySelectorAll('.btn-account');
const body = document.body;

// Hide the header while scrolling down, show it again as soon as the user scrolls up
let lastScrollY = window.scrollY;

window.addEventListener(
  'scroll',
  () => {
    if (!header) return;

    const scrollY = window.scrollY;

    // ignore tiny movements (trackpad jitter, iOS bounce)
    if (Math.abs(scrollY - lastScrollY) < 5) return;

    const scrollingDown = scrollY > lastScrollY;
    const pastHeader = scrollY > (header.querySelector('.m-header__nav') as HTMLElement).offsetHeight;
    const menuOpen = body.classList.contains('menu-is-open');

    header.classList.toggle('is-hidden', scrollingDown && pastHeader && !menuOpen);
    lastScrollY = scrollY;
  },
  { passive: true }
);

// Shop's categories (snippets/module-header.liquid). With a mouse they open on hover under
// Shop, in place of the link below it, which hides meanwhile; they stay a moment after the
// pointer leaves, and a click on Shop goes to the shop. In the phone menu the first tap on
// SHOP opens them and a second tap goes to the shop.
const phoneMenu = window.matchMedia('(max-width: 719px)');
header?.querySelectorAll<HTMLElement>('[data-header-sub]').forEach((item) => {
  const toggle = item.querySelector<HTMLElement>('.m-header__sub-toggle');
  if (!toggle) return;
  let closeTimer: number | undefined;

  const setOpen = (open: boolean) => {
    item.classList.toggle('is-open', open);
    // phone: the list has only just appeared, so lay it out first (reading its height does
    // that), then start its links' drop-in from there
    item.classList.remove('is-dropped');
    if (open && phoneMenu.matches) {
      void item.offsetHeight;
      item.classList.add('is-dropped');
    }
    toggle.setAttribute('aria-expanded', String(open));
    header?.classList.toggle('is-sub-open', open);
  };

  item.addEventListener('mouseenter', () => {
    if (phoneMenu.matches) return;
    window.clearTimeout(closeTimer);
    setOpen(true);
  });

  item.addEventListener('mouseleave', () => {
    if (phoneMenu.matches) return;
    closeTimer = window.setTimeout(() => setOpen(false), 150);
  });

  phoneMenu.addEventListener('change', () => setOpen(false));
  btnMenuClose?.addEventListener('click', () => setOpen(false));

  toggle.addEventListener('click', (event) => {
    if (!phoneMenu.matches || item.classList.contains('is-open')) return;
    event.preventDefault();
    setOpen(true);
  });
});

btnMenu?.addEventListener('click', () => {
  header?.classList.remove('is-hidden');
  body?.classList.toggle('menu-is-open');
});

btnMenuClose?.addEventListener('click', () => {
  body?.classList.remove('menu-is-open');
});

// Newsletter in the phone menu: close the menu and open the newsletter sign-up (like the footer link)
header?.querySelector('.btn-newsletter')?.addEventListener('click', (e) => {
  e.preventDefault();
  // see modules/footer.ts: a click outside the panel closes it, this link is outside
  e.stopPropagation();
  body?.classList.remove('menu-is-open');
  modalBottom.showModal();
});

btnCart?.addEventListener('click', (e) => {
  e.preventDefault();
  modal.showCart();
});

btnLogin?.forEach((btn) => {
  btn.addEventListener('click', (e) => {
    e.preventDefault();
    modal.showLogin();
    body?.classList.remove('menu-is-open');
  });
});

btnAccount?.forEach((btn) => {
  btn.addEventListener('click', (e) => {
    e.preventDefault();
    modal.showAccount();
    body?.classList.remove('menu-is-open');
  });
});